module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/more-topic-6.912047e1.jpg";